export default __webpack_public_path__ + "static/media/jackinaboxclosed.40eb8b4f.png";